const Industry = ["Residential","Commercial","Assisted Care & Hospital","Public Space"];

let industryList = [];
for(let i in Industry)
    industryList.push({ID:i,Name:Industry[i]});


const DocumentType = ["PowerPoint"];

let documentTypeList = [];
for(let i in DocumentType)
    documentTypeList.push({ID:i,Name:DocumentType[i]});

export { Industry,industryList,DocumentType,documentTypeList };
